import { useGuestSiteTelemetry } from '@apps/guest/GuestSite.telemetry';
import type { EventPageFragment } from '@graphql/fragments/event.page.graphql.generated';
import { useCallback } from 'react';
import { useGuestSitePageChanged } from '../../common/utils/useGuestSitePageChanged';
import { useMigratedCustomPageFeatureFlags } from '@shared/hooks/useMigratedCustomPageFeatureFlags/useMigratedCustomPageFeatureFlags';

export const useLayoutBrannanController = (pages: ReadonlyArray<EventPageFragment>) => {
  const telemetry = useGuestSiteTelemetry();
  const { isMigratedCustomPageEnabled } = useMigratedCustomPageFeatureFlags();

  useGuestSitePageChanged(pages, isMigratedCustomPageEnabled);

  // MENU
  const handleMenuClicked = useCallback(
    (pageClicked: string) => {
      telemetry.navMenuItemClicked(pageClicked);
    },
    [telemetry],
  );

  const handleMenuOpenedChange = useCallback(
    (opened: boolean) => {
      telemetry.navMenuOpenedChange(opened ? 'opened' : 'closed');
    },
    [telemetry],
  );

  // WELCOME SECTION
  const handleWelcomeRSVPButtonClicked = useCallback(() => {
    telemetry.welcomeRSVPButtonClicked();
  }, [telemetry]);

  //Footer Section
  const handleFooterButtonClicked = useCallback(
    (item: string) => {
      telemetry.footerItemClicked(item);
    },
    [telemetry],
  );

  //Edit Event
  const handleEditEventClicked = useCallback(() => {
    telemetry.editEventClicked();
  }, [telemetry]);

  return {
    handleMenuClicked,
    handleWelcomeRSVPButtonClicked,
    handleFooterButtonClicked,
    handleMenuOpenedChange,
    handleEditEventClicked,
  };
};
